import React, { Component } from 'react'
import Flickity from 'react-flickity-component'

import SliderNav from '~/components/core/sliderNav'
import ButtonArrow from '~/components/core/buttonArrow'

class Slider extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      canNextSlide: true,
      canPrevSlide: false,
      cellsCount: 1,
      items: 1,
      loop: false,
    }
  }

  componentDidMount = () => {
    // set groupCells for nav disable/enable arrow real count
    if (this.props.groupCells) {
      this.getGroupCells('init')

      window.addEventListener('orientationchange', () => {
        this.getGroupCells('resize')
      })
    }

    // if infinite, disable custom canPrevSlide/canNextSlide options
    if (this.props.flickityOptions.wrapAround) {
      this.setState({ canPrevSlide: true, loop: true })
    }

    // same height technique
    if (this.flkty && this.flkty.resize) {
      const resize = this.flkty.resize
      this.flkty.resize = () => {
        this.flkty.element.classList.remove(`flickity-resize`)
        resize.call(this.flkty)
        this.flkty.element.classList.add(`flickity-resize`)
      }
    }

    //TODO clean that and find if emitter can be sent on load font
    setTimeout(() => {
      this.flkty?.resize()

      // on change, manage disable/enable for prev/next arrows
      this.flkty.on('change', () => {
        if (!this.state.loop) {
          let canNextSlide
          const canPrevSlide = this.flkty.selectedIndex === 0 ? false : true

          if (this.props.groupCells) {
            if (this.props.flickityOptions.groupCells) {
              canNextSlide =
                this.flkty.selectedIndex * this.state.cellsCount <
                this.flkty.cells.length - this.state.cellsCount
                  ? true
                  : false
            } else {
              canNextSlide =
                this.flkty.selectedIndex <
                this.flkty.cells.length - this.state.cellsCount
                  ? true
                  : false
            }
          } else {
            canNextSlide =
              this.flkty.selectedIndex === this.flkty.cells.length - 1
                ? false
                : true
          }

          this.setState({
            canPrevSlide: canPrevSlide,
            canNextSlide: canNextSlide,
          })
        }
      })
    }, 1000)
  }

  // get group cells param
  getGroupCells = (type) => {
    let windowWidth = type === 'init' ? window.innerWidth : window.screen.width
    let group = JSON.parse(this.props.groupCells)
    let cellsCount = 1

    for (let [key, value] of Object.entries(group)) {
      if (windowWidth >= parseInt(key)) {
        cellsCount = value
      }
    }

    this.setState({ cellsCount: cellsCount })
  }

  nextSlide = () => {
    this.flkty.next()
  }

  prevSlide = () => {
    this.flkty.previous()
  }

  render() {
    return (
      <>
        <Flickity
          className={`slider ${this.props.classes}`} // default ''
          elementType={'div'} // default 'div'
          options={this.props.flickityOptions} // takes flickity options {}
          // disableImagesLoaded={true} // default false
          static // default false
          flickityRef={(c) => (this.flkty = c)}
        >
          {this.props.children}
        </Flickity>

        <div className={this.props.navClasses}>
          <SliderNav
            nextSlide={this.nextSlide}
            prevSlide={this.prevSlide}
            canNextSlide={this.state.canNextSlide}
            canPrevSlide={this.state.canPrevSlide}
            iconColor={this.props.iconColor}
          />

          {this.props.linkText && (
            <ButtonArrow
              className=""
              text={this.props.linkText}
              link={this.props.linkUrl}
              external={this.props.linkExternal}
              color={this.props.linkColor}
            />
          )}
        </div>
      </>
    )
  }
}

export default Slider
